import getAccommodationExtrasSaga from './getAccommodationExtras';
import getExtraAvailabilitySaga from './getExtraAvailability';
import getExtrasAvailabilitySaga from './getExtrasAvailability';
import getExtrasSaga from './getExtras';

export const extrasSagas = [
  getExtrasSaga,
  getAccommodationExtrasSaga,
  getExtrasAvailabilitySaga,
  getExtraAvailabilitySaga,
];
